export default __webpack_public_path__ + "static/media/a017-line7.81430997.svg";